import { _ } from "../../../core/polyglot/polyglot.js";
import { Decoration, DecorationSet } from "prosemirror-view";
import { Plugin } from "prosemirror-state";
import AbstractAction from "./AbstractAction.js";

/**
 * Action adding a placeholder in the editor when it is empty.
 */
export default class PlaceholderAction extends AbstractAction {
	constructor({ text = _("Type your text here") } = {}) {
		super();
		this._text = text;
	}

	getPlugins() {
		return [this._makePlugin(this._text)];
	}

	_makePlugin() {
		return new Plugin({
			props: { decorations: this._createDecorations.bind(this) },
		});
	}

	_isDocEdited(doc) {
		return (
			doc.childCount > 1 ||
			(doc.firstChild &&
				(!doc.firstChild.isTextblock ||
					doc.firstChild.content.size > 0))
		);
	}

	_createDecorations({ doc }) {
		if (this._isDocEdited(doc)) {
			return undefined;
		}

		const placeHolder = document.createElement("div");
		placeHolder.classList.add("placeholder");
		placeHolder.textContent = this._text;

		const decoration = Decoration.widget(1, placeHolder);
		return DecorationSet.create(doc, [decoration]);
	}
}
